export default {"src":"/_next/static/media/sber-logo.a0212193.svg","height":24,"width":89};